<template>
  <VLayout>
    <VFlex xs8>
      <VCard style="height: calc(100vh - 100px)">
        <VLayout justify-space-around row>
          <VFlex xs12>
            <VCardTitle style="font-variant: small-caps">
              <h1>Šifrant izdajateljev</h1>
              <v-spacer />
              <v-text-field
                v-model="query"
                label="Išči po davčni št. ali imenu"
                single-line
                hide-details
              />
              <v-btn color="primary" @click="search"> Išči </v-btn>
            </VCardTitle>
            <VContainer class="pa-0" fill-height fluid>
              <VLayout fill-height>
                <VFlex xs12>
                  <VDataTable
                    :headers="headers"
                    :items="documentIssuers"
                    :pagination.sync="pagination"
                    :rows-per-page-items="[5, 10, 25, 50]"
                    rows-per-page-text="Vrstic na stran"
                    :total-items="totalItems"
                  >
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-center">
                        {{ props.item.name }}
                      </td>
                      <td class="text-xs-center">
                        {{ props.item.vat_id }}
                      </td>
                      <td class="text-xs-center">
                        <v-icon v-if="props.item.allow_auto_forward" color="success"> done </v-icon>
                        <v-icon v-else color="red"> clear </v-icon>
                      </td>
                      <td class="text-xs-center">
                        <VTooltip top>
                          <VBtn
                            slot="activator"
                            flat
                            icon
                            color="green"
                            @click.stop="startEditing(props.item)"
                          >
                            <VIcon>edit</VIcon>
                          </VBtn>
                          <span>Uredite izdajatelja</span>
                        </VTooltip>
                        <VTooltip top>
                          <VBtn
                            slot="activator"
                            flat
                            icon
                            color="red"
                            @click.stop="deleteIssuer(props.item)"
                          >
                            <VIcon>delete</VIcon>
                          </VBtn>
                          <span>Izbrišite izdajatelja</span>
                        </VTooltip>
                      </td>
                    </template>
                    <template slot="no-data"> Ni podatkov za prikaz </template>
                  </VDataTable>
                </VFlex>
              </VLayout>
            </VContainer>
          </VFlex>
        </VLayout>
      </VCard>
    </VFlex>
    <VFlex xs4>
      <VCard style="height: calc(100vh - 100px); overflow-y: scroll">
        <VLayout justify-space-around row>
          <VFlex xs10>
            <VCardTitle style="padding: 10px 0 0 0; font-variant: small-caps">
              <h2>{{ currentActionText }}</h2>
            </VCardTitle>
            <VContainer fluid style="padding: 0 0 0 10px">
              <VForm ref="form" @submit.prevent="createNewIssuer">
                <VLayout fill-height row wrap>
                  <VFlex xs12>
                    <VTextField
                      v-model="issuerObject.name"
                      v-validate="'required'"
                      :error-messages="errors.collect('name')"
                      data-vv-name="name"
                      data-vv-as="Ime"
                      label="Ime"
                      type="string"
                    />
                  </VFlex>
                  <VFlex xs12>
                    <VTextField
                      v-model="issuerObject.vat_id"
                      v-validate="'required'"
                      :error-messages="errors.collect('vat_id')"
                      data-vv-name="vat_id"
                      data-vv-as="Davčna številka"
                      label="Davčna številka"
                      type="string"
                    />
                  </VFlex>
                  <VFlex xs12>
                    <v-checkbox
                      v-model="issuerObject.allow_auto_forward"
                      label="Dovoli avtomatsko posredovanje"
                      hint="Velja za izdajatelja kot dobavitelja. Samodejno posredovanje za naročnika nastavite na strani Partnerji."
                      persistent-hint
                      color="primary"
                    />
                  </VFlex>
                  <v-flex xs12 style="display: flex; justify-content: flex-end">
                    <VBtn v-if="editing" @click.stop="stopEditing"> Prekliči urejanje </VBtn>
                    <VBtn color="primary" :disabled="errors.any()" type="submit"> Potrdi </VBtn>
                  </v-flex>
                </VLayout>
              </VForm>
            </VContainer>
          </VFlex>
        </VLayout>
      </VCard>
    </VFlex>
  </VLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'DocumentIssuers',
  data() {
    return {
      headers: [
        {
          text: 'Ime',
          value: 'name',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Davčna številka',
          value: 'vat_id',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Avtomatsko posredovanje',
          value: 'allow_auto_forward',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Akcije',
          align: 'center',
          sortable: false,
        },
      ],
      issuerObject: null,
      emptyIssuerObject: {
        name: '',
        vat_id: '',
        allow_auto_forward: true,
      },
      editing: false,
      editingActionText: 'Uredi izdajatelja',
      createNewActionText: 'Dodaj izdajatelja',
      currentActionText: 'Dodaj izdajatelja',
      query: '',
      totalItems: 0,
      pagination: {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
      },
      previousPage: 1,
      lastKey: {
        current: null,
        previous: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      documentIssuers: 'documentIssuers',
    }),
  },
  watch: {
    pagination: {
      handler() {
        if (this.previousPage < this.pagination.page) {
          this.getDocumentIssuersAction({ start_key: this.lastKey.current, query: this.query });
        } else if (this.previousPage > this.pagination.page) {
          const params =
            this.lastKey.previous === null
              ? { start_key: this.lastKey.previous, query: this.query }
              : { query: this.query };
          this.getDocumentIssuersAction(params);
        }
        this.previousPage = this.pagination.page;
      },
      deep: true,
    },
    documentIssuers: {
      handler() {
        /* Update pagination ability */
        if (this.documentIssuers && this.documentIssuers.last_key) {
          this.lastKey.previous = this.lastKey.current;
          this.lastKey.current = this.documentIssuers.last_key;
          this.totalItems = this.documentIssuers.count || 0;
          this.pagination.totalItems = this.totalItems;
        }
      },
      deep: true,
    },
  },
  created() {
    this.issuerObject = this._.cloneDeep(this.emptyIssuerObject);
  },
  mounted() {
    this.getDocumentIssuersAction({});
  },
  methods: {
    ...mapActions([
      'getDocumentIssuersAction',
      'createDocumentIssuerAction',
      'updateDocumentIssuerAction',
      'deleteDocumentIssuerAction',
      'setSnackBarStateAction',
    ]),
    showSnackbar(successful, msg) {
      const snackbarColor = successful ? 'green' : 'red';
      this.setSnackBarStateAction({
        snackBar: true,
        color: snackbarColor,
        text: msg,
      });
    },
    startEditing(issuer) {
      this.issuerObject = this._.cloneDeep(issuer);
      this.editing = true;
      this.currentActionText = this.editingActionText;
      this.$validator.reset();
    },
    stopEditing() {
      this.issuerObject = this._.cloneDeep(this.emptyIssuerObject);
      this.editing = false;
      this.currentActionText = this.createNewActionText;
      this.$validator.reset();
    },
    async createNewIssuer() {
      const isValid = await this.$validator.validateAll();
      if (!isValid) return;

      try {
        if (this.editing) {
          await this.updateDocumentIssuerAction(this.issuerObject);
          this.showSnackbar(true, 'Izdajatelj je bil uspešno posodobljen.');
          this.stopEditing();
          // Refresh the current page to show the updated data
          this.getDocumentIssuersAction({
            start_key: this.pagination.page > 1 ? this.lastKey.previous : null,
            query: this.query,
          });
        } else {
          await this.createDocumentIssuerAction(this.issuerObject);
          this.showSnackbar(true, 'Izdajatelj je bil uspešno dodan.');
          this.stopEditing();
          // Go to first page to see the newly created item
          this.pagination.page = 1;
          this.getDocumentIssuersAction({ query: this.query });
        }
      } catch (err) {
        this.showSnackbar(
          false,
          'Napaka pri dodajanju/urejanju izdajatelja. Poskusite znova ali pokličite administratorja.'
        );
      }
    },
    async deleteIssuer(issuer) {
      try {
        await this.deleteDocumentIssuerAction(issuer);
        this.showSnackbar(true, `Uspešno ste izbrisali izdajatelja: ${issuer.name}`);
        // Refresh the current page
        this.getDocumentIssuersAction({
          start_key: this.pagination.page > 1 ? this.lastKey.previous : null,
          query: this.query,
        });
      } catch (err) {
        this.showSnackbar(
          false,
          'Napaka pri brisanju izdajatelja. Poskusite znova ali pokličite administratorja.'
        );
      }
    },
    async search() {
      // Reset to first page on search
      this.pagination.page = 1;
      this.lastKey = { current: null, previous: null };
      await this.getDocumentIssuersAction({ query: this.query });
    },
  },
};
</script>

<style scoped>
.v-text-field {
  padding: 0;
}
::v-deep .v-table__overflow {
  overflow: auto;
  max-height: 70vh;
}
</style>
